"use strict";

Object.defineProperty(exports, "__esModule", {
    value: true
});

var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };

var _slicedToArray = function () { function sliceIterator(arr, i) { var _arr = []; var _n = true; var _d = false; var _e = undefined; try { for (var _i = arr[Symbol.iterator](), _s; !(_n = (_s = _i.next()).done); _n = true) { _arr.push(_s.value); if (i && _arr.length === i) break; } } catch (err) { _d = true; _e = err; } finally { try { if (!_n && _i["return"]) _i["return"](); } finally { if (_d) throw _e; } } return _arr; } return function (arr, i) { if (Array.isArray(arr)) { return arr; } else if (Symbol.iterator in Object(arr)) { return sliceIterator(arr, i); } else { throw new TypeError("Invalid attempt to destructure non-iterable instance"); } }; }();

var _jquery = require("jquery");

var _jquery2 = _interopRequireDefault(_jquery);

var _isFunction = require("lodash/isFunction");

var _isFunction2 = _interopRequireDefault(_isFunction);

var _get_cookie = require("../helpers/get_cookie");

var _get_cookie2 = _interopRequireDefault(_get_cookie);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

// Like the CALL_API middleware but returns promise that resolves when request completes
var callApiPromise = function callApiPromise(_ref) {
    var types = _ref.types,
        endpoint = _ref.endpoint,
        method = _ref.method,
        data = _ref.data,
        _ref$actionPayload = _ref.actionPayload,
        actionPayload = _ref$actionPayload === undefined ? {} : _ref$actionPayload;
    return function (dispatch, getState) {
        var _types = _slicedToArray(types, 3),
            requestType = _types[0],
            successType = _types[1],
            failureType = _types[2];

        var csrfCookie = void 0;
        if (!global.csrfCookieName) {
            console.warn("global.csrfCookieName not set");
        } else {
            csrfCookie = (0, _get_cookie2.default)(csrfCookieName);
        }

        var requestTypeAction = (0, _isFunction2.default)(requestType) ? requestType() : _extends({}, actionPayload, { type: requestType });
        dispatch(requestTypeAction);
        return new Promise(function (resolve, reject) {
            var onError = function onError(error) {
                console.error("failed request", endpoint, method, error.statusText);
                var payload = { error: error };

                var failureTypeAction = (0, _isFunction2.default)(failureType) ? failureType(payload) : _extends({}, actionPayload, { type: failureType }, payload);
                dispatch(failureTypeAction);
                return reject(error);
            };

            _jquery2.default.ajax({
                type: method,
                url: endpoint,
                data: data,
                json: true,
                beforeSend: function beforeSend(xhr) {
                    if (csrfCookie) {
                        xhr.setRequestHeader("X-CSRFToken", csrfCookie);
                    }
                }
            }).done(function (response) {
                if (response && response.errors) {
                    return onError(response.errors);
                }
                var payload = _extends({}, actionPayload, {
                    response: response
                });
                var successTypeAction = (0, _isFunction2.default)(successType) ? successType(payload) : _extends({ type: successType }, payload);
                dispatch(successTypeAction);
                return resolve(response);
            }).fail(onError);
        });
    };
};

exports.default = callApiPromise;